export const specialMessageTypes = {
  generic: 'generic', // '[special-message] { ...specialMessageSchema.generic }
};

export const specialMessageSchema = {
  generic: { type: specialMessageTypes.generic, text: '' },
};

/**
 * @param {object} payload
 * @returns {string}
 */
export function generateSpecialMessage(payload = {}) {
  return `[special-message] ${JSON.stringify(payload)}`;
}
